/**
 * Language: English.
 */
export default {
    messages: {
        choose_thematic: "Choose Thematic",
        sessionReset: "Session will automatically reset in",
        minute: "minute",
        resetMap: "Reset Map",
        selectLanguage: "Select a Language",
        seconds: "seconds",
        cta: {
            "switch_standard_view": "Switch to standard view"
        },
        minutes: "minutes",
        multilevelwarning: "This is a multi-level path and goes via the Quick Link on Level 1",
        allexhibits: "All exhibitors",
        favorites: "Your exhibitors",
        select_thematic: "Select Thematics",
        allexhibits_mobile: "See all",
        favorites_mobile: "Your list",
        select_thematic_mobile: "Theme path",
        add_favorites: "Add to your exhibitors",
        remove_favorites: "Remove from your exhibitors",
        add_favorites_toast: "Exhibitor added to your list",
        remove_favorites_toast: "Exhibitor removed from your list",
        api_error: "You need to login to access your exhibitors",
        level: "Level",
    },
    thematics: {
        "umbrella": "Umbrellas and Pergolas",
        "smartoffice": "Smart Office",
        "eclectic": "Eclectic Design",
        "dol": "Domestic Outdoor lighting",
        "uol": "Urban Outdoor lighting",
        "homent": "Home Entertainment",
        "wallpaper": "Wallpaper",
        "rug": "Rugs",
    },
    thematicDescription: {
        "outdoor": "Design, durability and comfort: the constant evolution of furniture for gardens, terraces and small outdoor spaces.",
        "textile": "Textile journeys that weave cutting-edge technologies with unmistakable craftsmanship.",
        "wallpaper": "Solutions stemming from research on materials, patterns and colors, blending technique and aesthetics.",
        "kitchen": "Designs, custom furniture and solutions for hotels, apartment buildings, offices and retail spaces.",
        "bathroom": "Highly innovative interiors: water sustainability according to Salotto NY.",
    },
    errors: {
        loadingLibrary: "Failed to load the {library} script",
        geolocationFailed: "User Geolocation failed",
        apiErrors:{
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    },
};
